import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
require('dayjs/locale/de');

dayjs.extend(isoWeek);

export function formatDate(date: Date | string) {
  if (!date) {
    return '-';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return date.toLocaleDateString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  });
}

export function formatDateShort(date: Date | string) {
  if (!date) {
    return '-';
  }

  return dayjs(date).locale('de').format('DD. MMMM YYYY');
}

export function formatDateTime(date: Date | string) {
  if (!date) {
    return '-';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  return date.toLocaleTimeString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatISODateToYYYYMMDD(date: Date | string) {
  if (!date) {
    return '-';
  }

  if (typeof date === 'string') {
    date = new Date(date);
  }

  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, '0');
  const day = String(date.getUTCDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function computeFromEnumToDate(periodKey: string) {
  const now = dayjs();

  switch (periodKey) {
    case 'last_24h':
      return { from: now.subtract(1, 'day').toISOString(), to: now.toISOString() };

    case 'this_week':
      return { from: now.startOf('isoWeek').toISOString(), to: now.toISOString() };

    case 'last_week': {
      const lastWeek = now.subtract(1, 'week');
      return {
        from: lastWeek.startOf('isoWeek').toISOString(),
        to: lastWeek.endOf('isoWeek').toISOString(),
      };
    }

    case 'week_before_last': {
      const weekBeforeLast = now.subtract(2, 'week');
      return {
        from: weekBeforeLast.startOf('isoWeek').toISOString(),
        to: weekBeforeLast.endOf('isoWeek').toISOString(),
      };
    }

    default:
      return {};
  }
}
